<template>
  <v-content>
    <ImpersonationBanner />
    <router-view />
  </v-content>
</template>

<script>
  import ImpersonationBanner from '../core/ImpersonationBanner.vue';

  export default {
    name: 'DashboarduserView',

    components: {
      ImpersonationBanner
    },
  }
</script>
